import { ShieldCheck, AlertTriangle } from 'lucide-react';

// Tells the reader where the AI disclosure + offshore clauses are in this letter.
export const ClausesNote = ({ state, client = false }) => {
  if (state === 'missing_signed') {
    return (
      <p className="flex items-start gap-2 rounded-md border border-warning/40 bg-warning/10 p-2 text-xs" data-testid="clauses-note-missing">
        <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0 text-warning" />
        {client ? 'This letter was signed before our AI and offshore disclosures were added. We will send you a short addendum to acknowledge them.'
          : 'Signed before the AI and offshore clauses existed. The signed letter is not altered – send the consent addendum from Client engagements → Send to existing clients.'}
      </p>);
  }
  if (!state) return null;
  return (
    <p className="flex items-start gap-2 text-xs text-muted-foreground" data-testid={`clauses-note-${state}`}>
      <ShieldCheck className="mt-0.5 h-3.5 w-3.5 shrink-0 text-success" />
      Includes the “Artificial Intelligence (AI) and Technology-Assisted Services” and “Offshore Employees, Outsourcing and Cross-Border Data Access” clauses{state === 'pinned' ? ' (version fixed when the letter was sent)' : state === 'current' ? ' (current version; fixed when the letter is sent)' : ''}. Scroll to the end of the letter to read them.
    </p>);
};
